import { ClockCircleOutlined } from '@ant-design/icons';
import { Timeline } from 'antd';
import { getTaskStore } from 'core/modules/tasks/task.store';
import moment from 'moment';
import { useMemo } from 'react';
import styled from 'styled-components';
import { TaskActivityItem } from './Activity/Item';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TaskActivity = function TaskActivity(_ref) {
  var task = _ref.task;

  var _getTaskStore = getTaskStore(),
      populateTask = _getTaskStore.populateTask;

  var populatedTask = useMemo(function () {
    return populateTask(task);
  }, [task.id]);
  return useMemo(function () {
    return /*#__PURE__*/_jsxs(Container, {
      mode: "left",
      reverse: true,
      children: [task.activity.map(function (item, index) {
        return /*#__PURE__*/_jsx(TaskActivityItem, {
          task: populatedTask,
          activity: item
        }, index);
      }), /*#__PURE__*/_jsx(Timeline.Item, {
        dot: /*#__PURE__*/_jsx(ClockCircleOutlined, {
          style: {
            fontSize: '16px'
          }
        }),
        pending: true,
        color: populatedTask !== null && populatedTask !== void 0 && populatedTask.deadline ? 'red' : undefined,
        label: " ",
        children: (populatedTask === null || populatedTask === void 0 ? void 0 : populatedTask.deadline) && /*#__PURE__*/_jsxs("span", {
          children: ["Deadline ", moment(task === null || task === void 0 ? void 0 : task.deadline).fromNow()]
        })
      })]
    });
  }, [task.activity]);
}; // Styles

var Container = styled(Timeline).withConfig({
  displayName: "Activity__Container",
  componentId: "sc-te23q2-0"
})([""]);